import { Component,ChangeDetectorRef } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetHealthBoxComponent } from '../../asset-health-box/asset-health-box.component';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { LineChartComponent } from '../line-chart/line-chart.component';
import { GaugeChartComponent } from '../device-detail-nxt/gauge-chart-component/gauge-chart-component.component';
import { CommonModule } from '@angular/common';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment-timezone';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { AssetDetailsBoxComponent } from '../../asset-details-box/asset-details-box.component';
import { NgApexchartsModule } from 'ng-apexcharts';



@Component({
  selector: 'app-gauge-monitoring-dashboard',
  standalone: true,
  imports: [NgbNavModule,AssetHealthBoxComponent,MatMenuModule,MatIconModule,MatButtonModule,LineChartComponent,GaugeChartComponent,CommonModule,MatMenu,MatButton,SpinnerComponent,AssetDetailsBoxComponent,NgApexchartsModule],
  templateUrl: './gauge-monitoring-dashboard.component.html',
  styleUrl: './gauge-monitoring-dashboard.component.scss'
})
export class GaugeMonitoringDashboardComponent {
  public baseGaugeMonitoringUrl= BaseUrlConstantsService.BASE_GAUGE_MONITORING_SERVICE;
  public gauge_value: any;
  gauge_bottom_lable: any = "0 °C";
  public avgValArray: any = [];
  lastFileProcessedTime = "";
  client_id: any;
  subsystem_id: any;
  asset_id: any;
  device_id: any;
  mac_address="C400005"
  machineVibrationLoading = true;
  avgValLoading = true;
  options: any = {
    arcColors: ['#72FF13', '#FAA700', '#ff2a1b'], // default to 3 colors
    arcDelimiters: [30, 70],
    arcLabels: [36,84],    // e.g. [4.5, 11.2]
    hasNeedle: true,
    needleColor: '#72FF13',
    needleStartValue: 0,
    needleUpdateSpeed: '',
    rangeLabel: ['0', '120']
  };

  public cylinderBaseUrl = BaseUrlConstantsService.CYLINDER_BASE_URL;
  accLoading = true;
  accelerationLineData = [];
  // accelerationColors = [];
  accLineChartOptions = "";
  accLineUnit = "";
 accLineMovingAvg = [];
  accMovingCount = 0;

  public company_name: string;
  public today: string;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "Image Monitoring",
    },
    {
      page_ref: "#",
      page_title: "Gauge Monitoring",
    },
  ];
constructor(
  private cdr: ChangeDetectorRef,
    private service: BackendApiService,
    private router: Router,
    public dialog: MatDialog,
    // private activatedRoute: ActivatedRoute
  ) {
    // setTimeout(() => {
    //   this.machineVibrationLoading = false;
    // }, 2000);
  }

  ngOnInit() {
    this.utcTime();
    this.company_name = localStorage.getItem('company_name') || '';
    if (localStorage.getItem("role") === "ACCOUNT_MANAGER") {
      this.client_id = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "USER") {
      this.client_id = localStorage.getItem("associated_clientid");
    } else if (localStorage.getItem("role") === "ADMIN") {
      this.client_id = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "OEM") {
      this.client_id = localStorage.getItem("admin_client_id");
    } else {
      this.client_id = localStorage.getItem("user_id");
    }
    this.fetchGaugeData();
    this.fetchGaugeStatistics() 
    this.getDailyTemperatureData()
  }

 
  
  fetchGaugeData() {
    const url = this.baseGaugeMonitoringUrl + "/getLatestVal/" + this.client_id + "/" + this.mac_address;
    this.service.getDataV2(url).then((response: any) => {
      if (response) {
        this.gauge_value = response.value;
        this.gauge_bottom_lable = `${response.value} °C`;
        // ← HERE: you overwrite avgValArray (intended only for “statistics”)
        this.avgValArray = response.avgValArray || [];
        this.machineVibrationLoading = false;
      }
    });
  }
  
  fetchGaugeStatistics() {
    const url = this.baseGaugeMonitoringUrl + "/getAverages/" + this.client_id + "/" + this.mac_address;
    this.service.getDataV2(url).then((response: any) => {
      if (response) {
        const unit = response.unit || '°C';
        const averagesData = [
          { name: "Daily Average",      value: response.daily_avg },
          { name: "Three Day Average",  value: response.three_day_avg },
          { name: "Weekly Average",     value: response.weekly_avg }
        ];
  
        // THIS is where avgValArray was supposed to be set
        this.avgValArray = averagesData.map(avg => ({
          bottom_label: `${avg.value} ${unit}`,
          value: avg.value,
          name: avg.name
        }));
  
        // console.log("Updated avgValArray:", this.avgValArray);
        this.avgValLoading = false;
        this.cdr.detectChanges();
      } else {
        this.avgValArray = [];
      }
    }).catch((error: any) => {
      console.error("Error fetching gauge statistics:", error);
      this.avgValArray = [];
    });
  }
  chartReady: boolean = false;

  dailyTemperatureDataJson: any = [];
  tempChartOptions: string = 'Temperature Trends';
  tempUnit: string = '°C';

  // Thresholds for Line Chart coloring (will be stringified JSON)
  temperatureThresholdColorsJson: any = [];

  // Data for the Gauge (a single numerical value)
  currentTemperature: number | null = null;

  // Loading state
  isLoadingTempData: boolean = false;

  // accelerationLineData: any[] = [];
  accelerationColors: any[] = [];

  dailyTemperatureData: any[] = []; // Renamed for clarity
  // Define simple thresholds for temperature line coloring
  temperatureThresholdColors: any[] = [
    { value: 10, color: '#add8e6' }, // Light blue for cold (<= 10°C)
    { value: 20, color: '#28a745' }, // Green for moderate (<= 20°C)
    { value: 30, color: '#ffc107' }, // Yellow for warm (<= 30°C)
    { value: 999, color: '#dc3545' }    // Red for hot (> 30°C), use a very high value for the upper bound
  ];
 
  public getDailyTemperatureData(): void {
    this.isLoadingTempData = true;
    this.chartReady = false;

    setTimeout(() => {
      const now = moment();
      const tempSensorData: any[] = [];

      for (let i = 0; i < 96; i++) {
        const time = now.clone().startOf('day').add(i * 15, 'minutes');
        const timestamp = time.toISOString();

        const hour = time.hour() + (time.minute() / 60);
        const baseTemp = 25 + 10 * Math.sin(Math.PI * (hour - 4) / 12);
        const randomFluctuation = (Math.random() * 4) - 2;
        const tempValue = parseFloat((baseTemp + randomFluctuation).toFixed(2));

        tempSensorData.push({
          label: timestamp,
          y: tempValue
        });
      }

      const lineChartData = [
        {
          dataPoints: tempSensorData,
          name: 'Device Temperature',
          type: 'line',
          unit: this.tempUnit
        }
      ];

      const lineChartThresholdsConfig = {
          green: 20,
          yellow: 30,
          red: 999,
          max_value: tempSensorData.length > 0 ? Math.max(...tempSensorData.map(d => d.y)) + 5 : 40
      };

      this.dailyTemperatureDataJson = lineChartData;
      this.temperatureThresholdColorsJson = lineChartThresholdsConfig;

      if (tempSensorData.length > 0) {
        this.currentTemperature = tempSensorData[tempSensorData.length - 1].y;
      } else {
        this.currentTemperature = null;
      }

      this.isLoadingTempData = false;
      this.chartReady = true;
      // console.log("JSON sent to line-chart (after setTimeout):", this.dailyTemperatureDataJson);
      this.cdr.detectChanges();
    }, 1000);
  }
    // setTimeout(() => {
    //   this.machineVibrationLoading = false;
    // }, 2000); // Corrected: removed the extra comma

    
  utcTime() {
      setInterval(() => {
        this.today = new ConvertDatetimePipe().convertDateTime(new Date());
      }, 1000);
    }



    viewAsset() {}



}
